import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW1406Component } from './kymw1406.component';
import { GetGoodsInfoListService } from './api-services/get-goods-info-list.service';
import { UpdateGoodsInfoService } from './api-services/update-goods-info.service';
import { GetCrossMultiService } from './api-services/get-cross-multi.service';

/**
 * 商品情報画面 モジュール設定クラス
 *
 * @export KYMW1406Module
 * @class KYMW1406Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjInputModule,
    FontAwesomeModule,
  ],
  declarations: [
    KYMW1406Component,
  ],
  providers: [
    GetGoodsInfoListService,
    UpdateGoodsInfoService,
    GetCrossMultiService,
  ],
})
export class KYMW1406Module {
}
